import trans from '../../helpers/trans'
import { UsersRoutes } from '../helpers'
import { SubNavRoute } from '../routes'

export type UserNavigationRouteKey = 'users-overview';

const userNavigationRoutes: SubNavRoute[] = [
    {
        key: 'users-overview',
        path: UsersRoutes.users(),
        label: trans('routes.users.users.label'),
        permissions: ['view-all-user-profiles'],
    },
]

export default userNavigationRoutes
